export enum RegisterStepThreeResponse {
  DEFAULT,
  CONTACT,
}
